import "../chunk-UKSPFOP7.js";
import { ClerkProvider, __internal__setErrorThrowerOptions } from "./ClerkProvider";
export {
  ClerkProvider,
  __internal__setErrorThrowerOptions
};
//# sourceMappingURL=index.js.map